// src/api/finance.js
import { BASE_API } from "../utils/constants";

/** Helpers **/
const authHeader = (token) => ({
  Authorization: `Bearer ${token}`,
});

/* =======================
   SALES
   ======================= */
export async function getSalesApi(token, params = {}) {
  try {
    const query = new URLSearchParams(params).toString();
    const url = `${BASE_API}/api/finance/sales/${query ? `?${query}` : ""}`;
    const response = await fetch(url, { headers: authHeader(token) });
    if (!response.ok) throw new Error("Error al cargar ventas");
    return await response.json();
  } catch (err) {
    throw err;
  }
}

export async function createSaleApi(data, token) {
  try {
    const url = `${BASE_API}/api/finance/sales/`;
    const params = {
      method: "POST",
      headers: {
        ...authHeader(token),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const res = await fetch(url, params);
    const result = await res.json();
    if (!res.ok) throw result;
    return result;
  } catch (err) {
    throw err;
  }
}

export async function updateSaleApi(id, data, token) {
  try {
    const url = `${BASE_API}/api/finance/sales/${id}/`;
    const params = {
      method: "PATCH",
      headers: {
        ...authHeader(token),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const res = await fetch(url, params);
    const result = await res.json();
    if (!res.ok) throw result;
    return result;
  } catch (err) {
    throw err;
  }
}

export async function deleteSaleApi(id, token) {
  try {
    const url = `${BASE_API}/api/finance/sales/${id}/`;
    const params = { method: "DELETE", headers: authHeader(token) };
    const res = await fetch(url, params);
    if (!res.ok) throw new Error("No se pudo eliminar la venta");
    return true;
  } catch (err) {
    throw err;
  }
}

/* Payments by Sale */
export async function getSalePaymentsApi(id, token) {
   // Usa el ViewSet de payments con filtro por sale
   const url = `${BASE_API}/api/finance/payments/?sale=${id}`;
    const res = await fetch(url, { headers: authHeader(token) });
    if (!res.ok) throw new Error("Error al cargar pagos");
    return await res.json();
  }

export async function addPaymentToSaleApi(id, data, token) {
  try {
    const url = `${BASE_API}/api/finance/payments/`;
    const params = {
      method: "POST",
      headers: {
        ...authHeader(token),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...data, sale: id }),
    };
    const res = await fetch(url, params);
    const result = await res.json();
    if (!res.ok) throw result;
    return result;
  } catch (err) {
    throw err;
  }
}



/* =======================
   METRICS
   ======================= */
export async function getFinanceMetricsApi(token, params = {}) {
  try {
    const query = new URLSearchParams(params).toString();
    const url = `${BASE_API}/api/finance/metrics/${query ? `?${query}` : ""}`;
    const res = await fetch(url, { headers: authHeader(token) });
    if (!res.ok) throw new Error("Error al cargar métricas");
    return await res.json();
  } catch (err) {
    throw err;
  }
}
